export default [
    {
        path: '/varianceanalysis',
        component: "__base",
        otherdata: { color: "caccounting", module: "Commentary Workflow" },
        children: [
            {
                // module: "TDS",
                path: "dashboard",
                component: "Dashboard.vue",
                meta: { title: "Dashboard" },
            },
            {
                // module: "TDS",
                path: "actualanalysis",
                component: "Analysis/ActualCycle.vue",
                meta: { title: "Actual Cycle" },
            },
            {
                // module: "TDS",
                path: "forecastanalysis",
                component: "Analysis/ForecastCycle.vue",
                meta: { title: "Forecast Cycle" },
            },
            {
                // module: "TDS",
                path: "approvals",
                component: "Approvals/Approvals.vue",
                meta: { title: "Approvals Management" },
            },
            {
                // module: "TDS",
                path: "threshold",
                component: "Threshold.vue",
                meta: { title: "Materiality" },
            },
            {
                // module: "TDS",
                path: "addthreshold",
                component: "Analysis/AddMateriality.vue",
                meta: { title: "Materiality" },
            },
            {
                // module: "TDS",
                path: "accessrights",
                component: "AccessManagement/AccessRights.vue",
                meta: { title: "Role Management" },
            },
            {
                // module: "TDS",
                path: "glselection",
                component: "GLforMngtCommentary.vue",
                meta: { title: "GL & Drill down Selection" },
            },
            {
                // module: "TDS",
                path: "cyclereport",
                component: "Reports/CycleReport.vue",
                meta: { title: "Cycle Report" },
            },
            {
                // module: "TDS",
                path: "datareport",
                component: "Reports/DataReport.vue",
                meta: { title: "Data Report" },
            },
            {
                // module: "TDS",
                path: "materialityreports",
                component: "Reports/MaterialityReports.vue",
                meta: { title: "Materiality Reports" },
            },
            {
                // module: "TDS",
                path: "useraccessreport",
                component: "Reports/UserAccessReport.vue",
                meta: { title: "User Access Report" },
            },
            {
                // module: "TDS",
                path: "approvalsreport",
                component: "Reports/ApprovalsReport.vue",
                meta: { title: "Approvals Report" },
            },
            {
                // module: "TDS",
                path: "datacentreport",
                component: "Reports/DataCentreReport.vue",
                meta: { title: "Data Centre Report" },
            },
            {
                // module: "TDS",
                path: "glmanagement",
                component: "GLManagement.vue",
                meta: { title: "GL List" },
            },
            {
                // module: "TDS",
                path: "dataprocessing",
                component: "DataCenter/DataProcessing.vue",
                meta: { title: "Data Processing" },
            },
            {
                path: "dataprocessing/dataprocessingdetails/:id?",
                name: "dataprocessing-details",
                component: "DataCenter/components/DataProcessingDetails.vue",
                meta: { title: "Data Processing Details" },
                props: true
            },
            {
                // module: "TDS",
                path: "userpermission",
                component: "UserPermission/UserPermission.vue",
                meta: { title: "User Permissions" },
            },
            {
                // module: "TDS",
                path: "userpermission/userpermissionaddaccess/:userId?",
                component: "UserPermission/components/UserPermissionAddAccess.vue",
                meta: { title: "User Permission Add Access" },
            },
            {
                // module: "TDS",
                path: "emailnotification",
                component: "EmailNotification.vue",
                meta: { title: "Email Notifications" },
            },
            {
                // module: "TDS",
                path: "myreportingunits",
                component: "MyReportingUnit/MyReportingUnits.vue",
                meta: { title: "My Reporting Units" },
            },
            {
                // module: "TDS",
                path: "reportingunit/reportingdetails/:id",
                component: "MyReportingUnit/components/ReportingUnitDetails.vue",
                meta: { title: "Reporting Unit Details" },
            },
            {
                // module: "TDS",
                path: "ai",
                component: "AiView.vue",
                meta: { title: "AI", url: "/v2/client/get-all-features" },
                props: route => ({ url: route.meta.url })
            },
          
            {
                path: "commentary/:cycleId",
                component: "GLBreakdown.vue",
                meta: { title: "Commentary Breakup" },
                props: route => ({ type: 'commentary', cycleId: route.params.cycleId })
            },
            {
                path: "workflow",
                component: "WorkflowConfig/Workflow.vue",
                meta: { title: "Workflow" },
            },
            {
                path: "workflow/bulk-edit",
                component: "WorkflowConfig/components/WorkflowBulkEdit.vue",
                meta: { title: "Bulk Workflow Configuration" },
                name: "WorkflowBulkEdit"
            },
            {
                path: "workflow/edit/:id",
                component: "WorkflowConfig/components/WorkflowEditDetails.vue",
                meta: { title: "Workflow Edit Details" },
                name: "WorkflowEditDetails",
                props: true
            },
            {
                path: "queue",
                component: "QueueManagement/QueueManagement.vue",
                meta: { title: "Queue Management" },
            },
            {
                // module: "TDS",
                path: "*",
                component: "",
            },
        ],
    },
]

